/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PermissionVm,
    PermissionVmFromJSON,
    PermissionVmFromJSONTyped,
    PermissionVmToJSON,
    SimpleUserForUserRoleRelationVmPaginatedSearchResponse,
    SimpleUserForUserRoleRelationVmPaginatedSearchResponseFromJSON,
    SimpleUserForUserRoleRelationVmPaginatedSearchResponseFromJSONTyped,
    SimpleUserForUserRoleRelationVmPaginatedSearchResponseToJSON,
    UserPermissionRelationVm,
    UserPermissionRelationVmFromJSON,
    UserPermissionRelationVmFromJSONTyped,
    UserPermissionRelationVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserPermissionRelationsVm
 */
export interface UserPermissionRelationsVm {
    /**
     * 
     * @type {SimpleUserForUserRoleRelationVmPaginatedSearchResponse}
     * @memberof UserPermissionRelationsVm
     */
    users?: SimpleUserForUserRoleRelationVmPaginatedSearchResponse;
    /**
     * 
     * @type {Array<PermissionVm>}
     * @memberof UserPermissionRelationsVm
     */
    permissions?: Array<PermissionVm> | null;
    /**
     * 
     * @type {Array<UserPermissionRelationVm>}
     * @memberof UserPermissionRelationsVm
     */
    relations?: Array<UserPermissionRelationVm> | null;
}

export function UserPermissionRelationsVmFromJSON(json: any): UserPermissionRelationsVm {
    return UserPermissionRelationsVmFromJSONTyped(json, false);
}

export function UserPermissionRelationsVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionRelationsVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': !exists(json, 'users') ? undefined : SimpleUserForUserRoleRelationVmPaginatedSearchResponseFromJSON(json['users']),
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'] === null ? null : (json['permissions'] as Array<any>).map(PermissionVmFromJSON)),
        'relations': !exists(json, 'relations') ? undefined : (json['relations'] === null ? null : (json['relations'] as Array<any>).map(UserPermissionRelationVmFromJSON)),
    };
}

export function UserPermissionRelationsVmToJSON(value?: UserPermissionRelationsVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': SimpleUserForUserRoleRelationVmPaginatedSearchResponseToJSON(value.users),
        'permissions': value.permissions === undefined ? undefined : (value.permissions === null ? null : (value.permissions as Array<any>).map(PermissionVmToJSON)),
        'relations': value.relations === undefined ? undefined : (value.relations === null ? null : (value.relations as Array<any>).map(UserPermissionRelationVmToJSON)),
    };
}


